import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent } from "@/lib/consent";
import { initPostHog } from "@/lib/posthog";
import { Button } from "@/components/ui/button";

interface CookieConsentProps {
  forceOpen?: boolean;
  onClose?: () => void;
}

const CookieConsent = ({ forceOpen = false, onClose }: CookieConsentProps) => {
  const [visible, setVisible] = useState(() => getConsent() === null);

  useEffect(() => {
    if (forceOpen) setVisible(true);
  }, [forceOpen]);

  if (!visible) return null;

  const dismiss = () => {
    setVisible(false);
    onClose?.();
  };

  const handleAccept = () => {
    setConsent("accepted");
    initPostHog();
    dismiss();
  };

  const handleReject = () => {
    setConsent("rejected");
    dismiss();
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 border-t border-border bg-card p-4 shadow-lg">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-3 sm:flex-row sm:justify-between">
        <p className="text-sm text-muted-foreground text-center sm:text-left">
          We use cookies and analytics to understand product usage and improve the service.{" "}
          <Link to="/privacy" className="text-primary underline underline-offset-2 hover:text-primary/80">
            Privacy Policy
          </Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={handleReject}>
            Reject
          </Button>
          <Button size="sm" onClick={handleAccept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
